// reused once so checking a list of cards doesn't allocate a parser per call
const richTextScratch = document.createElement('template');

/**
 * True when a rich-text/HTML string has no visible text — empty, tags only,
 * or whitespace/whitespace-entities (e.g. a quill `&emsp;`/`&nbsp;` placeholder).
 * Parses real HTML, so entities decode and `trim()` handles nbsp/emsp.
 */
export const isRichTextEmpty = (value?: string): boolean => {
	if (!value) return true;
	richTextScratch.innerHTML = value;
	return (richTextScratch.content.textContent ?? '').trim().length === 0;
};
